<script>
import StudentsService from '@/services/StudentsService';

export default {
	methods: {
		async checkProfileCreationFor(step, studentId) {
			return await StudentsService.isProfileCreationStepCompleted(
				step,
				studentId
			);
		}
	}
};
</script>
